export default __webpack_public_path__ + "ui/assets/img/archive-20.svg";